export default __webpack_public_path__ + "static/media/ecomm-logo.5e37ef62.png";